<template>
  <div>

    <!--Banner Parallax-->
    <section class="topBanner" ref="parallaxBanner" :style="{ backgroundPositionY: parallaxOffset + 'px' }">
      <div class="bannerOverlay">
        <h1 class="bannerTitle">{{ $t('intro.title') }}</h1>
      </div>
    </section>

    <!--Armstrong-->
    <section id="armstrong" class="bgLogo sectionPad gridpad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="10">
          <div class="armstrongBox">
            <h2 class="pumpSectionTitle txt-c">{{ $t('pumpArmstrong.title') }}</h2>
            <p class="mt-5 txt-j" v-html="$t('pumpArmstrong.text')"></p>
            <ol class="olPad">
              <li v-html="$t('pumpArmstrong.ol1')"></li>
              <li v-html="$t('pumpArmstrong.ol2')"></li>
              <li v-html="$t('pumpArmstrong.ol3')"></li>
              <li v-html="$t('pumpArmstrong.ol4')"></li>
              <li v-html="$t('pumpArmstrong.ol5')"></li>
              <li v-html="$t('pumpArmstrong.ol6')"></li>
              <li v-html="$t('pumpArmstrong.ol7')"></li>
              <li v-html="$t('pumpArmstrong.ol8')"></li>
            </ol>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--ContactUs-->
    <contactUs/>

    <!--Accessoires-->
    <section class="sectionPad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" class="txt-c mb-2">
          <h2 class="pumpSectionTitle">{{ $t('Accessoires.title') }}</h2>
        </v-col>
      </v-row>
      <armstrong/>
    </section>

  </div>
</template>

<style scoped>
  p { font-size: 18px; color: rgba(var(--menuColor), 0.6); }
  .sectionPad { padding: 50px 0px; }
  .gridpad { padding-bottom: 50px; }
  .olPad { text-align: justify; padding: 20px 40px; }
  ol li { padding: 10px 0px; font-size: 18px; color: rgba(var(--menuColor), 0.6); }

  /*#region Banner Parallax*/
  .topBanner {
    height: 600px;
    background-image: url('../../public/Resources/images/Banner/bannerHighPressureWasher.jpg');
    background-attachment: fixed;
    background-position: center 30%;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    will-change: background-position-y;
  }
  .bannerOverlay {
    background-color: rgba(0, 0, 0, 0.45);
    padding: 40px 70px;
    border-radius: 8px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    max-width: 700px;
  }
  .bannerTitle {
    color: #ffffff;
    font-weight: 700;
    font-size: 32px;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin: 0;
  }
  /*#endregion*/

  /*#region Armstrong section with logo watermark*/
  .bgLogo { position: relative; }
  .bgLogo::before {
    content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.1;
    transform: rotate(-5deg);
    background-image: url('../../public/Resources/images/Products/armstrong/armstrong_logo_blackred.png');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
  }
  .armstrongBox { padding: 0px 0px 32px 0px; }
  /*#endregion*/

  /*#region Unified Titles*/
  .pumpSectionTitle { color: rgb(var(--secondary)); font-weight: 700; font-size: 26px; }
  /*#endregion*/

  @media handheld, only screen and (max-width: 600px) {
    .topBanner { height: 400px; background-attachment: scroll; }
    .bannerTitle { font-size: 22px; }
    .bannerOverlay { padding: 25px 20px; }
    .olPad { padding: 20px 15px; }
  }
  @media handheld, only screen and (max-width: 960px) {
    .topBanner { height: 500px; background-attachment: scroll; }
    .gridpad { padding: 25px 25px 50px 25px; }
    .sectionPad { padding: 30px 0px; }
  }
  @media handheld, only screen and (max-width: 1279px) {
    .topBanner { height: 500px; background-attachment: scroll; }
  }
</style>

<script>
  import pageTranslations from '../../public/Resources/i18N/armstrong.json';
  import contactUs from '@/components/bannerContactUs.vue';
  import armstrongComp from '@/components/armstrong.vue';

  export default {
    name: 'ArmstrongPage',
    data: () => ({
      parallaxOffset: 0,
    }),
    methods: {
      handleParallax() {
        if (!this.$refs.parallaxBanner) return;
        this.parallaxOffset = Math.round(window.scrollY * 0.4);
      },
    },
    mounted() {
      this.$i18n.mergeLocaleMessage('fr', pageTranslations.fr);
      this.$i18n.mergeLocaleMessage('en', pageTranslations.en);
      window.addEventListener('scroll', this.handleParallax);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleParallax);
    },
    components: {
      contactUs,
      armstrong: armstrongComp,
    },
  }
</script>